import React, { useEffect, useState } from "react";
import Quiz from "../quiz/Quiz";
import Training from "../training/Training";
import { useHistory } from "react-router-dom";
import useAuth from "../../utils/customHooks/useAuth";
import { Endpoints } from "../../repository/Endpoints";
import { PostMaker } from "../../repository/RequestMaker";
import { Spinner } from "react-bootstrap";

const Trainer = () => {
  useAuth();
  const history = useHistory();
  const [material, setMaterial] = useState({});
  const [current_material, setCurrent_material] = useState("");
  const [materialType, setMaterialType] = useState("");
  const [materialChangerToggle, setMaterialChangerToggle] = useState(false);
  const [loadingGroupTraining, setLoadingGroupTraining] = useState(false);

  useEffect(() => {
    checkMaterialLength();
    const _current_material = localStorage.getItem("current_material");
    const _material = JSON.parse(localStorage.getItem("material"));
    console.log(_material[_current_material]);
    setMaterial(_material[_current_material]);
    setCurrent_material(_current_material);
  }, [materialChangerToggle]);

  useEffect(() => {
    if (!material) {
      history.push({
       // pathname: "/courses",
        pathname: "/projects",

      });
      return;
    }
    if (Object.keys(material).length === 0) {
      return;
    }
    setMaterialType(material.material_type.const);
  }, [material]);

  useEffect(() => {
    const trainingType = localStorage.getItem("trainingType");
    const _material = JSON.parse(localStorage.getItem("material"));
    const _material_length = _material.length;
    if (trainingType === "grouptraining") {
      setLoadingGroupTraining(true);
      grouptrainingMaterialSelector(_material, _material_length);
    }
  }, []);

  const materialChanger = () => {
    checkMaterialLength();
    localStorage.setItem("current_material", Number(current_material) + 1);
    setMaterialChangerToggle(!materialChangerToggle);
  };

  const checkMaterialLength = () => {
    if (
      Number(current_material) + 1 >=
      JSON.parse(localStorage.getItem("material")).length
    ) {
      console.log("all material done");
      localStorage.setItem("current_material", Number(current_material) + 1);
      // history.push({
      //   pathname: "/certificate",
      // });
      history.push({
        pathname: "/quiz",
      });

      return;
    }
  };

  const renderTraining = (type) => {
    if (type === "VIDEO_STANDALONE") {
      return (
        <Training
          vidUrl={material.public_video_url}
          materialChanger={materialChanger}
          material_id={material.id}
        />
      );
    } 
    // else if (type === "TEST") {
    //   return (
    //     <Quiz
    //       material_id={material.id}
    //       material_name={material.name}
    //       materialChanger={materialChanger}
    //     />
    //   );
    // }
  };

  const grouptrainingMaterialSelector = (_material, _material_length) => {
    // Extract all material IDs
    const section_material_ids = _material.map((material) => material.id);
  
    // Post the array of IDs to the backend
    PostMaker(
      {
        section_material_id: section_material_ids, // send as an array now
        course_enrollment_id: localStorage.getItem("enrollment_id"),
      },
      Endpoints.material_progress
    ).then((response) => {
      localStorage.setItem(
        "response" + Math.random(),
        JSON.stringify(response)
      );
      setTimeout(() => {}, 200);
    });
  
    // Set the first non-VIDEO_STANDALONE type to state to start with a test if needed
    const firstTestMaterial = _material.find(
      (material) => material.material_type.const === "TEST"
    );
    if (firstTestMaterial) {
      setMaterial(firstTestMaterial);
      setCurrent_material(_material.indexOf(firstTestMaterial));
      setMaterialType("TEST");
      setLoadingGroupTraining(false);
    }
  };
  
  return (
    <>
      {loadingGroupTraining ? (
        <Spinner animation="grow" />
      ) : (
        renderTraining(materialType)
      )}
    </>
  );
};

export default Trainer;
